import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import socialPrintTemplateStrings from './contextualStrings';
import ContextualString from '../../../../../../../../components/contextual/ContextualString';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    join_code: PropTypes.string,
    is_web_gallery: PropTypes.bool,
    album_subtype: PropTypes.string.isRequired,
  }).isRequired,
  account: PropTypes.shape({
    id: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    organization_name: PropTypes.string.isRequired,
  }).isRequired,
};

const SocialPrintTemplateSellPhotosJoinCode = ({ albumFolder, account }) => {
  return (
    <Fragment>
      <p className="marketing-material-social-main-copy">
        <ContextualString
          id="socialSellPhotosMainCopy"
          defaultMessage="Get your photo proofs texted to you and purchase prints directly from your mobile device!"
          type={albumFolder.album_type}
          subtype={albumFolder.album_subtype}
          strings={socialPrintTemplateStrings}
          values={{
            orgName: account.organization_name,
          }}
        />
      </p>
      <p
        className="marketing-material-social-cta-copy"
        style={{ bottom: '34%' }}
      >
        To receive your photo proofs, text our Join Code below to
        <br />
        735-343:
      </p>
      <p
        className="marketing-material-social-target-copy text-uppercase"
        style={{ bottom: '30%' }}
      >
        {albumFolder.join_code}
      </p>
      {albumFolder.is_web_gallery && (
        <Fragment>
          <p className="marketing-material-social-footer-or">or</p>
          <p className="marketing-material-social-footer-copy">
            Visit <span>waldophotos.com/galleries</span> and enter the Join Code
            above to view your photos on the web!
          </p>
        </Fragment>
      )}
    </Fragment>
  );
};

SocialPrintTemplateSellPhotosJoinCode.propTypes = propTypes;

export default SocialPrintTemplateSellPhotosJoinCode;
